import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CashRegisterService {


  url = environment.serverAPI5 + '/' + 'api/cashRegister';
	cartCount: Response[];

	constructor(private http: HttpClient) { }

	addCashRegister(cashRegister): Observable<Response[]> {
		return this.http.post<Response[]>(`${this.url}`, cashRegister);
	}

  checkCashRegisterActive(): Observable<Response[]> {
		return this.http.get<any>(`${this.url}/active`);
	}

  getCashregisterData(): Observable<Response[]> {
		return this.http.get<any>(`${this.url}/active/data`);
	}
}
